/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
const PropTypes = require('prop-types');
const React = require('react');

const developmentMode = `
  window.mParticle = {
    config: {
      isDevelopmentMode: true // switch to false (or remove) for production
    }
  };
`;

/**
 * MParticle renders the mParticle script and basic config
 *
 * @param {Object} props component props
 * @returns {Object} React component
 */
function MParticle(props) {
  const { apiKey, isActive, isDevelopment } = props;
  if (!isActive) {
    return null;
  }

  const developmentModeConfig = isDevelopment ? developmentMode : '';
  const script = `
      ${developmentModeConfig}

      window.mParticle = window.mParticle || {};
      window.mParticle.eCommerce = { Cart: {} };
      window.mParticle.Identity = {};
      window.mParticle.config = window.mParticle.config || {};
      window.mParticle.config.rq = [];

      window.mParticle.config.identityCallback = function (result) {
        if (result.httpCode === 200 || result.httpCode === -3) {
          // Publish identity success event
          // Used by subscribers that depend on the mParticle identity existing (e.g. UTM tracking)
          var eventName = 'mParticle:identity-success';
          if (typeof Event === 'function') {
            document.dispatchEvent(new Event(eventName));
          }
          // Keep old behavior in place
          if (typeof window.SC !== 'undefined' && SC.utils && SC.utils.pubsub) {
            SC.utils.pubsub.publish(eventName);
          }
        }
      }
      window.mParticle.ready = function (f) {
          window.mParticle.config.rq.push(f);
      };

    (function (apiKey) {
      function a(o,t){return function(){t&&(o=t+"."+o);var e=Array.prototype.slice.call(arguments);e.unshift(o),window.mParticle.config.rq.push(e)}}var x=["endSession","logError","logEvent","logForm","logLink","logPageView","setSessionAttribute","setAppName","setAppVersion","setOptOut","setPosition","startNewSession","startTrackingLocation","stopTrackingLocation"],y=["setCurrencyCode","logCheckout"],z=["login","logout","modify"];x.forEach(function(o){window.mParticle[o]=a(o)}),y.forEach(function(o){window.mParticle.eCommerce[o]=a(o,"eCommerce")}),z.forEach(function(o){window.mParticle.Identity[o]=a(o,"Identity")});

      var mp = document.createElement('script');
      mp.type = 'text/javascript';
      mp.async = true;
      mp.src = ('https:' == document.location.protocol ? 'https://jssdkcdns' : 'http://jssdkcdn') + '.mparticle.com/js/v2/' + apiKey + '/mparticle.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(mp, s);
    })('${apiKey}');

    //Log a page view for mparticle on every page
    window.mParticle.ready(function () {
      var attrs = {
        'request_referrer': document.referrer,
        'request_host': window.location.host,
        'request_pathname': window.location.pathname,
        'request_search': window.location.search
      };

      mParticle.logEvent('page view', mParticle.EventType.Navigation, attrs);
    });
  `;

  // eslint-disable-next-line react/no-danger
  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}

MParticle.propTypes = {
  /**
   * apiKey for mParticle integration
   */
  apiKey: PropTypes.string.isRequired,
  /**
   * flag indicating if analytics should be active
   */
  isActive: PropTypes.bool.isRequired,
  /**
   * flag corresponding to the mode mParticle should be running
   */
  isDevelopment: PropTypes.bool,
};

MParticle.defaultProps = {
  isDevelopment: false,
};

module.exports.default = MParticle;
